import { FREEZE_WORDS } from '@/lib/freezeWords';

/** R0c · the move's banner, only while the platform is frozen for the AWS cutover (lib/platformFreeze.ts). */
export function FreezeBanner({ until }: { until: string | null | undefined }) {
  if (until === undefined) return null;
  const by = until ? new Date(until).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' }) : null;
  return (
    <div role="status" aria-live="polite" className="bg-amber-100 text-amber-900 text-xs font-bold px-4 py-2">
      {FREEZE_WORDS}{by ? ` Back by about ${by} ET.` : ''}
    </div>
  );
}

